import React from 'react';
import { User, Users } from 'lucide-react';

interface ClientResponsibleProps {
  name: string;
  role?: string;
}

export default function ClientResponsible({ name, role }: ClientResponsibleProps) {
  const getInitials = (n: string) => {
    if (!n) return '?';
    const parts = n.trim().split(/\s+/);
    if (parts.length > 1) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return parts[0][0]?.toUpperCase() || '?';
  };

  const isTeam = name.toLowerCase().includes('equipe') || name.toLowerCase().includes('comercial');

  // Generate deterministic gentle pastel color for background based on name
  const getBgColor = (n: string) => {
    if (isTeam) return 'bg-indigo-50 text-indigo-700 border-indigo-100';
    const colors = [
      'bg-blue-50 text-blue-700 border-blue-100',
      'bg-emerald-50 text-emerald-700 border-emerald-100',
      'bg-violet-50 text-violet-700 border-violet-100',
      'bg-pink-50 text-pink-700 border-pink-100',
      'bg-amber-50 text-amber-700 border-amber-100',
    ];
    let sum = 0;
    for (let i = 0; i < n.length; i++) sum += n.charCodeAt(i);
    return colors[sum % colors.length];
  };

  const bgStyle = getBgColor(name);

  return (
    <div className="flex items-center gap-2.5">
      <div className={`w-8 h-8 rounded-full border flex items-center justify-center font-bold text-[11px] shrink-0 shadow-3xs ${bgStyle}`}>
        {isTeam ? <Users size={12} strokeWidth={2.5} /> : getInitials(name)}
      </div>
      <div className="flex flex-col text-left">
        <span className="text-xs font-bold text-slate-800 leading-tight">{name}</span>
        <span className="text-[10px] font-medium text-slate-400 leading-none mt-0.5">
          {role || (isTeam ? 'Relacionamento' : 'Account Manager')}
        </span>
      </div>
    </div>
  );
}
